import { Button } from '@/components/ui/button';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { Form, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { z } from 'zod';
import useResetPassword from '../hooks/useResetPassword';

export function ResetPassword() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { resetPassword, resetPasswordLoading } = useResetPassword();

	const resetSchema = z.object({
		email: z.string().email({ message: t('register.error.email') }),
	});

	const form = useForm<z.infer<typeof resetSchema>>({
		resolver: zodResolver(resetSchema),
		defaultValues: {
			email: '',
		},
	});

	const onSubmit = (values: z.infer<typeof resetSchema>) => {
		resetPassword(values);
		navigate('/reset-password/confirm', {
			state: { email: values.email },
		});
	};

	return (
		<Card className="mx-auto -mt-9 max-w-sm self-center">
			<CardHeader>
				<CardTitle className="text-2xl">
					{t('resetPassword.title')}
				</CardTitle>
				<CardDescription>
					{t('resetPassword.description')}
				</CardDescription>
			</CardHeader>
			<CardContent>
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="grid gap-4"
					>
						<div className="grid gap-4">
							<FormField
								control={form.control}
								name="email"
								render={({ field }) => (
									<FormItem>
										<Input
											className="text-base"
											id="email"
											inputMode="email"
											disabled={resetPasswordLoading}
											label={t(
												'resetPassword.input.email.label'
											)}
											placeholder={t(
												'resetPassword.input.email.placeholder'
											)}
											{...field}
										/>
										<FormMessage />
									</FormItem>
								)}
							/>
							<Button
								type="submit"
								className="w-full"
								isLoading={resetPasswordLoading}
							>
								{t('resetPassword.button.submit')}
							</Button>
						</div>
						<div className="mt-4 text-center text-sm">
							<Link to="/" className="underline">
								{t('resetPassword.backToLogin')}
							</Link>
						</div>
					</form>
				</Form>
			</CardContent>
		</Card>
	);
}
